import React, { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Tab,
  Tabs,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
  Drawer,
  ListItemText,
  List,
  ListItemButton,
  ListItem,
  ListItemIcon
} from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import InputAdornment from "@mui/material/InputAdornment";
import Input from "@mui/material/Input";
import MenuIcon from '@mui/icons-material/Menu';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import { Link, useNavigate } from "react-router-dom";
import memoji from '../../assets/Memoji.svg'
import RouteIcon from "@mui/icons-material/Route";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";

export default function FilterNavbar() {
  const [navColor, setnavColor] = useState("transparent");
  const [getValLocal, setValLocal] = useState(false);
  const listenScrollEvent = () => {
    window.scrollY > 10 ? setnavColor("#F9FFFF") : setnavColor("transparent");
    // window.scrollY > 10 ? setnavSize("5rem") : setnavSize("5rem");
  };

  const handleLogout = () => {
    localStorage.removeItem("navBtn");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setTimeout(() => {
      setValLocal(false);
      toggleDrawer("right", false);
      window.location.reload(true)
    }, 1000);
  };


  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  const dashboardList1 = [
    {
      title: "Track Order",
      icon: <RouteIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "My Activity",
      icon: <BoltOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "Saved Address",
      icon: <GroupsOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "My Payments",
      icon: <CreditCardOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "Favourite",
      icon: <FavoriteBorderOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "Promotions",
      icon: <LocalOfferOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
    {
      title: "Gift Card",
      icon: <WorkspacePremiumOutlinedIcon />,
      arrow: <ArrowForwardIosOutlinedIcon />,
    },
  ];

  const list = (anchor) => (
    <Box
      sx={{
        width:
          anchor === "top" || anchor === "bottom"
            ? "auto"
            : { lg: 377, md: 377, sm: 377, xs: "100%" },
        padding: "32px 16px",
      }}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box sx={{ display: "flex", flexDirection: "row", pb: "24px" }}>
        <Box sx={{ width: "56px", height: "56px" }}>
          <img
            src="./images/Drop your Memoji here.svg"
            alt=""
            width="100%"
            height="auto"
          />
        </Box>
        <Box sx={{ pl: "16px" }}>
          <Typography
            sx={{
              fontSize: {
                xl: "",
                lg: "16px",
                md: "16px",
                sm: "16px",
                xs: "16px",
              },
            }}
          >
            {userFullName}
          </Typography>
          <Link to="/dashboard" component="button">
            <Typography
              color="primary"
              sx={{
                fontSize: {
                  xl: "",
                  lg: "14px",
                  md: "14px",
                  sm: "14px",
                  xs: "14px",
                },
              }}
            >
              View Profile
            </Typography>
          </Link>
        </Box>
      </Box>

      <List sx={{ color: "#1A1824" }}>
        <ListItemText
          primary={"My Account"}
          sx={{ color: "#9EA3AE", pb: "20px" }}
        ></ListItemText>

        {dashboardList1 &&
          dashboardList1.map((item, index) => (
            <ListItem key={item.title} disablePadding>
              <ListItemButton onClick={() => navigate("/dashboard")}>
                <ListItemIcon
                  sx={{ minWidth: "24px", mr: "10px", color: "#1A1824" }}
                >
                  {/* <img width="100%" src={item.icon} alt="" /> */}
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.title} sx={{ color: "#1A1824" }} />
                {item.arrow}
              </ListItemButton>
            </ListItem>
          ))}

        <ListItem
          disablePadding
          sx={{
            backgroundColor: "#F0FAF9",
            borderRadius: "4px",
            height: "94px",
            pt: "10px",
          }}
        >
          <ListItemButton>
            <ListItemText>
              <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
                Get 10% off your order
              </Typography>
              <Typography
                sx={{ fontSize: "16px", fontWeight: "400", color: "#20615C" }}
              >
                Can only be used for today
              </Typography>
            </ListItemText>
            <ArrowForwardIosOutlinedIcon />
          </ListItemButton>
        </ListItem>

        <ListItemText
          primary={"General"}
          sx={{ color: "#9EA3AE", pb: "20px", mt: "8px" }}
        ></ListItemText>

        <ListItem disablePadding>
          <ListItemButton onClick={() => navigate("/GetHelp")}>
            <ListItemIcon>
              <HelpOutlineOutlinedIcon sx={{ fill: "#1A1824" }} />
            </ListItemIcon>
            <ListItemText primary={"Help"} />
            <ArrowForwardIosOutlinedIcon />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <WorkspacePremiumOutlinedIcon sx={{ fill: "#E75C62" }} />
            </ListItemIcon>
            <ListItemText primary={"Logout"} sx={{ color: "#E75C62" }} />
            <ArrowForwardIosOutlinedIcon sx={{ fill: "#E75C62" }} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  const [value, setValue] = useState();

  const [userFullName, setUserFullName] = useState("");
  const [state, setState] = React.useState({
    right: false,
  });
  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData !== null)
      setUserFullName(JSON.parse(userData).profile.fullName);
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const [openDrawer, setOpenDrawer] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenDrawer(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpenDrawer(false);
  };

  let navigate = useNavigate();

  return (
    <>
      <Box
        component="container"
        sx={{
          margin: "20px",
          padding: "0px",
          display: "flex",
          flexDirection: "row",
          justifyContent:'space-between',
          alignItems:'center',
          backgroundColor: navColor,
        }}
      >
        <Box
          sx={{
            width: {
              xl: "199.91px",
              lg: "150px",
              md: "150px",
              sm: "150px",
              xs: "100px",
            },
            height: { lg: "32px", md: "30px", sm: "28px", xs: "30px" },
          }}
        >
          <Link to="/" style={{textDecoration:'none'}}>
            <img src="./images/eatcoast.svg" alt="" width="100%" /></Link>
        </Box>


        <Box
          sx={{
            display: {lg:"flex",md:'flex',sm:'none',xs:'none'},
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box
              sx={{
                width: {lg: "40px", md: "40px", sm: "25px", xs: "20px"},
                height: {lg: "40px", md: "40px", sm: "25px", xs: "20px"},
                paddingLeft: {
                  xl: "130.09px",
                  lg: "130.09px",
                  md: "30px",
                  sm: "50px",
                  xs: "30px",
                },
                paddingRight: "16px",
                // paddingTop: "8px"
              }}
            >
              <img
                src="./images/Frame 720.svg"
                alt=""
                width="100%"
                // height="auto"
              />
            </Box>

            <Box
              sx={{
                borderBottom: "2px solid",
                color: "#F6F6F6",
                width: {lg: "149.57px", md: "149.57px", sm: "90px", xs: "100px"},
              }}
            >
              <Typography
                sx={{
                  fontSize: {lg: "16px", md: "16px", sm: "12px", xs: "12px"},
                  fontWeight: "400",
                  color: "#000000",
                  paddingTop: "4px",
                }}
              >
                George Street, St.
              </Typography>
            </Box>
            <Box sx={{ 
              paddingLeft: "2px", paddingTop: {lg: "8px", md: "8px", sm: "6px", xs: "4px"},
              width: {lg: "24px", md: "24px", sm: "20px", xs: "18px"}
               }}>
              <img src="./images/gps.svg" alt="" width="100%" height="auto" />
            </Box>

            <Box sx={{ paddingLeft: "16.43px" }}>
              <Input
                // fullWidth
                // sx={{width: {lg: "100%", md: "45%", sm: "200px"}}}
                disableUnderline="true"
                startAdornment={
                  <InputAdornment position="start">
                    <Box sx={{
                        width: {lg: "17.75px", md: "17.75px", sm: "14px", xs: "12px"},
                        height: "20.5px",
                      }}>
                    <img
                      src="./images/search-normal.svg"
                      width= "100%"
                      
                    />
                    </Box>
                  </InputAdornment>
                }
                sx={{
                  borderColor: "#E1E1E6",
                  border: "1px solid",
                  width: {
                    xl: "390px",
                    lg: "390px",
                    md: "245px",
                    sm: "200px",
                    xs: "100px",
                  },
                  height: {
                    lg: "40px",
                    md: "36px",
                    sm: "30px",
                    xs: "30px",
                  },
                  borderRadius: "4px",
                  padding: "15px, 24px, 15px, 24px",
                  gap: { lg: "16px", md: "16px", sm: "0px", xs: "0px" },
                  backgroundColor: "#F6F6F6",
                  color: "#9EA3AE",
                  paddingLeft: "27.12px",
                }}
              ></Input>
            </Box>
          </Box>

          {userFullName !== null && userFullName !== "" ? (
                <Box
                  sx={{
                    width: { xl: "60%", lg: "50%", md: "30%" },
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "end",
                  }}
                >
                  <Button
                    onClick={toggleDrawer("right", true)}
                    size="small"
                    sx={{
                      marginLeft: {
                        xl: "8px",
                        lg: "8px",
                        md: "8px",
                        sm: "8px",
                        xs: "4px",
                      },
                      borderRadius: "6px",
                      fontSize: {
                        lg: "16px",
                        md: "12px",
                        sm: "12px",
                        xs: "12px",
                      },
                      fontWeight: "600",
                      height: {
                        lg: "45px",
                        md: "45px",
                        sm: "30px",
                        xs: "22px",
                      },
                      width: { lg: "30px", md: "30px", sm: "30px", xs: "22px" },
                      backgroundColor: "#D5E6E5",
                      border: "none",
                      boxShadow: "0px 0px 0px",

                      // width: "97px",
                    }}
                    variant="contained"
                  >
                    <img src={memoji} />
                  </Button>
                  <Drawer
                    anchor={"right"}
                    open={state["right"]}
                    onClose={toggleDrawer("right", false)}
                  >
                    {list("right")}
                  </Drawer>
                </Box>
              ) : (
                <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Box
              sx={{
                paddingLeft: {
                  xl: "136px",
                  lg: "112px",
                  md: "40px",
                  sm: "20px",
                  xs: "20px",
                },
              }}
            >
              <Button
                startIcon={<ShoppingBagIcon/>}
                sx={{
                  // marginLeft: "auto",
                  // borderRadius: "6px",
                  // fontSize: { lg: "16px", md: "12px", sm: "12px", xs: "12px" },
                  // fontWeight: "600",
                  textTransform: "capitalize",
                  // height: {lg: "40px", md: "40px", sm: "30px", xs: "22px"},
                  // width: {lg: "81px", md: "81px", sm: "50px", xs: "40px"},
                }}

                variant="text"
                
              >
                Cart(0)
              </Button>
            </Box>

            <Box>
              <Button
              size="small"
                sx={{
                  marginLeft: {
                    xl: "8px",
                    lg: "8px",
                    md: "8px",
                    sm: "8px",
                    xs: "4px",
                  },
                  borderRadius: "6px",
                  fontSize: { lg: "16px", md: "12px", sm: "12px", xs: "12px" },
                  fontWeight: "600",
                  height: {lg: "40px", md: "40px", sm: "30px", xs: "22px"},
                  textTransform: "capitalize",
                  // width: "97px",
                }}
                variant="contained"
                onClick={()=> navigate('/register')}
              >
                Sign Up
                 </Button>
                </Box>
              </Box>
              )}

          {/* <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Box
              sx={{
                paddingLeft: {
                  xl: "136px",
                  lg: "112px",
                  md: "40px",
                  sm: "20px",
                  xs: "20px",
                },
              }}
            >
              <Button
                startIcon={<ShoppingBagIcon/>}
                sx={{
                  // marginLeft: "auto",
                  // borderRadius: "6px",
                  // fontSize: { lg: "16px", md: "12px", sm: "12px", xs: "12px" },
                  // fontWeight: "600",
                  textTransform: "capitalize",
                  // height: {lg: "40px", md: "40px", sm: "30px", xs: "22px"},
                  // width: {lg: "81px", md: "81px", sm: "50px", xs: "40px"},
                }}

                variant="text"
                
              >
                Cart(0)
              </Button>
            </Box>

            <Box>
              <Button
              size="small"
                sx={{
                  marginLeft: {
                    xl: "8px",
                    lg: "8px",
                    md: "8px",
                    sm: "8px",
                    xs: "4px",
                  },
                  borderRadius: "6px",
                  fontSize: { lg: "16px", md: "12px", sm: "12px", xs: "12px" },
                  fontWeight: "600",
                  height: {lg: "40px", md: "40px", sm: "30px", xs: "22px"},
                  textTransform: "capitalize",
                  // width: "97px",
                }}
                variant="contained"
                onClick={()=> navigate('/register')}
              >
                Sign Up
              </Button>
            </Box>
          </Box> */}

          
        </Box>

        <Box sx={{
          display:{lg:'none',md:'none',sm:'flex',xs:'flex'},
          flexDirection:'row',
          justifyContent:'end'
        }}>
                <Box>
                  <IconButton aria-label="delete" onClick={handleClick}>
                    <MenuIcon/>
                  </IconButton>

                  <Drawer
        anchor="top"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        width="100%"
      >
        <Box>
          <Box>
            {" "}
            <Button
              sx={{
                width: "100%",
                justifyContent: "left",
                textTransform: "capitalize",
              }}
            >
              Cart
            </Button>
          </Box>
          <Box>
            {" "}
            <Button
              sx={{
                width: "100%",
                justifyContent: "left",
                textTransform: "capitalize",
              }}
            >
              Signup
            </Button>
          </Box>

          

          <Box>
            {" "}
            <Button
              sx={{
                width: "100%",
                justifyContent: "left",
                textTransform: "capitalize",
              }}
            >
              search
            </Button>
          </Box>
        </Box>
                </Drawer>
                
                </Box>
        </Box>
        
      </Box>
    </>
  );
}
